import PropTypes from 'prop-types'
import PrivateRoute from 'router/PrivateRoute'
import routeMemo from 'router/routeMemo'
import RouteNotFound from 'router/RouteNotFound'
import { store } from 'state/_store'

/**
 * A wrapper for <PrivateRoute> that redirects to orders screen if you're authenticated but not authorized to see this screen.
 * @param children
 * @param check {function(state: object)} The restriction checker. Receives the whole Redux state as sole argument... but can't really run hooks, because the freaking "rule of hooks". Thus, for instance, privilege checks must be executed inside the page, through {@link User.useFullPagePrivilege()}.
 * @param component
 * @param render {function({ location: object })}
 * @param routeProps
 */
function RestrictedRoute({ children, check, component: Component, render = null, ...routeProps }) {
	const state = store.getState()
	return (
		<PrivateRoute {...routeProps} render={({ location }) =>
			check(state)?
				(children || (render? render() : false) || <Component location={routeProps.location}/>) :
				(<RouteNotFound location={location}/>)
		} />
	)
}
RestrictedRoute.propTypes = {
	check: PropTypes.func.isRequired,
}

export default routeMemo(RestrictedRoute)
